/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const createInterviewBookingTokensResponseSchema = z.object({
	tokens: z.array(
		z.object({
			id: z.string(),
			candidateId: z.string(),
			token: z.string(),
			bookingUrl: z.string(),
			status: z.union([
				z.literal('pending'),
				z.literal('booked'),
				z.literal('cancelled'),
				z.literal('expired'),
				z.literal('invalidated'),
			]),
			expiresAt: z.iso.datetime(),
			createdAt: z.iso.datetime(),
			durationMinutes: z.number(),
			minAdvanceNoticeHours: z.number(),
			bookingWindowDays: z.number(),
			meetingLocationType: z.union([
				z.literal('jobilla_meet'),
				z.literal('google_meet'),
				z.literal('teams'),
				z.literal('zoom'),
				z.literal('phone'),
				z.literal('in_person'),
				z.literal('custom'),
			]),
			meetingLocationDetails: z.string().nullable(),
			description: z.string().nullable(),
			deliveryChannels: z.array(z.union([z.literal('email'), z.literal('whatsapp')])),
		}),
	),
})

export type CreateInterviewBookingTokensResponseSchema = z.infer<typeof createInterviewBookingTokensResponseSchema>
